import * as React from "react";

import { BlogPost } from "@/types";
import BlogPostListItem from "../blog-post-list-item";

type BlogPostsProps = {
  blogs: BlogPost[];
};

/**
 * Component for displaying a list of blog posts.
 *
 * @param blogs - The list of blog posts to display.
 */
const BlogPosts: React.FC<BlogPostsProps> = ({ blogs }) => {
  return (
    <ul className="relative my-20 flex w-full flex-col gap-4">
      {blogs.map((blog) => (
        <BlogPostListItem key={blog.metadata?.slug} blog={blog.metadata} />
      ))}
    </ul>
  );
};

export default BlogPosts;
